export default __webpack_public_path__ + "static/media/MOTIVO_06.c04024d5.jpg";